function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { isFunction, recursiveSort } from '../utils';
export default {
  computed: {
    defaultSortColumn: function defaultSortColumn() {
      var flatColumns = this.flatColumns;
      return flatColumns.filter(function (v) {
        return v.defaultSortOrder;
      })[0];
    },
    sortColumns: function sortColumns() {
      var flatColumns = this.flatColumns;
      return flatColumns.filter(function (v) {
        return 'sortOrder' in v;
      });
    }
  },
  methods: {
    isSortColumn: function isSortColumn(column) {
      var sortColumn = this.sortInfo.column;

      if (!sortColumn || !column) {
        return false;
      }

      return sortColumn.$$_key === column.$$_key;
    },
    setSortInfo: function setSortInfo(sortInfo) {
      this.sortInfo = sortInfo;
    },
    initSortInfo: function initSortInfo() {
      var useDefaultSortOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var defaultSortColumn = this.defaultSortColumn,
          sortColumns = this.sortColumns,
          sortInfo = this.sortInfo,
          setSortInfo = this.setSortInfo;
      var sort = sortInfo; // 受控模式

      if (sortColumns.length > 0) {
        var col = sortColumns.filter(function (v) {
          return v.sortOrder;
        })[0] || {
          order: null
        };
        sort = {
          column: col,
          order: col.sortOrder
        };
      } else if (useDefaultSortOrder) {
        if (defaultSortColumn) {
          sort = {
            column: defaultSortColumn,
            order: defaultSortColumn.defaultSortOrder
          };
        }
      }

      setSortInfo(sort);
    },
    sortData: function sortData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var childColName = this.childColName,
          _this$sortInfo = this.sortInfo,
          sortColumn = _this$sortInfo.column,
          order = _this$sortInfo.order;

      var nData = _toConsumableArray(data);

      if (!sortColumn || !order || !isFunction(sortColumn.sorter)) {
        return nData;
      }

      var sorter = sortColumn.sorter;

      var sortFn = function sortFn(a, b) {
        var r = sorter(a, b);

        if (r !== 0) {
          return order === 'descend' ? -r : r;
        }

        return r;
      };

      return recursiveSort(nData, sortFn, childColName);
    },
    toggleOrder: function toggleOrder(column, order) {
      var isSortColumn = this.isSortColumn,
          sortOrder = this.sortInfo.order,
          setSortInfo = this.setSortInfo,
          onPagerOrFiterOrSortChange = this.onPagerOrFiterOrSortChange;
      var r = {
        column: null,
        order: null
      };

      if (isSortColumn(column)) {
        if (order !== sortOrder) {
          r = {
            column: column,
            order: order
          };
        }
      } else {
        r = {
          column: column,
          order: order
        };
      }

      setSortInfo(r);
      onPagerOrFiterOrSortChange();
    }
  }
};